import { EarningsItemBase, earnings } from '@api/api/earnings';
import { useQuery } from '@tanstack/react-query';
import { wretchRequest } from '@terminal/utils/api-fetch/apiFetch';

const QUERY_KEY_EARNING_BY_ID = 'QUERY_KEY_EARNING_BY_ID';

export const useGetEarningById = (id: string | undefined = '') =>
  useQuery({
    queryKey: [QUERY_KEY_EARNING_BY_ID, id],
    queryFn: ({ signal }) => {
      const { path, schema } = earnings.getEarningById;
      return wretchRequest<EarningsItemBase>(path(id), {
        method: 'get',
        schema,
        signal,
      });
    },
    staleTime: 0,
    gcTime: 0,
    enabled: !!id,
  });
